import useTranslation from "@babackapp/translations/use-translation";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters.ts";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import useCountFilteredReturnRequests from "@babackapp/private-api-client/client/use-count-filtered-return-requests";
import { useCallback, useEffect } from "react";
import QuickFilterItem from "@/pages/(app)/returns/list/components/quick-filters/quick-filter-item.tsx";
import { ShoppingCart } from "lucide-react";
import { yellow } from "@/pages/(app)/home/components/colors.tsx";

export default function MarketplaceQuickFilter() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const { filters, clearAll, quickFilter, setQuickFilter } =
    useReturnRequestsFilters();

  const isCarrierIssues = quickFilter === "marketplace";
  const active = isCarrierIssues;

  const onClick = useCallback(() => {
    clearAll();

    setQuickFilter("marketplace");
  }, [filters, active, isCarrierIssues]);

  const { data: results, refetch } = useCountFilteredReturnRequests({
    shopId: shop.id,
    filters,
    quickFilter: "marketplace",
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <QuickFilterItem
      count={results?.totalCount}
      active={active}
      title={t("returnRequestsQuickFilters.marketplace.title")}
      description={t("returnRequestsQuickFilters.marketplace.description")}
      icon={<ShoppingCart className="size-3" color={yellow} />}
      onClick={onClick}
    />
  );
}
